import React, { Component } from 'react';
import Parse                from 'parse';
import Spinner              from '../../generic/spinner';
import BankDetailsHolder    from './bankdetails-holder';
import CardHolder           from './card-holder';
import Api                  from '../../../Utils/api';
import Utils                from '../../../Utils/Utility';


export default class Billing  extends Component {

    // contextTypes is used to pushed the routes in url
    static contextTypes = {
        router : React.PropTypes.object.isRequired
    }

    constructor(props){
        super(props);

        this.state = {
            isUserSessionInvalid : false
        }
        // this.fetchBillingDetails = this.fetchBillingDetails.bind(this);
        // this.getConstDisplayName = this.getConstDisplayName.bind(this);
    }

    // fetchBillingDetails() {
    //     if (!this.state.activeLocation) {
    //         return;
    //     }
    //
    //     // if (!Utils.isEmptyObj(this.state.locConfig)) {
    //     //     return;
    //     // }
    //
    //     // this.setState({
    //     //     showSpinner : true
    //     // });
    //
    //
    //     // let currentUser  = Parse.User.current();
    //     // let locId        = this.state.activeLocation.objectId;
    //     // let userId       = currentUser.id;
    //     // let bizId        = this.props.bizId;
    //     // let sessionToken = Parse.User.current().getSessionToken();
    //     //
    //     // Api.fetchBillingDetails(userId, sessionToken, bizId)
    //     //     .then(
    //     //         (responseData, textStatus, jqXHR) => {
    //     //             let value = responseData;
    //     //             // console.log(value);
    //     //
    //     //             if(responseData.data){
    //     //                 let locConfig = responseData.data;
    //     //                 if(locConfig){
    //     //                     this.setState({
    //     //                         locConfig,
    //     //                         showSpinner : false
    //     //                     });
    //     //                 }
    //     //             }
    //     //         },
    //     //         (error, textStatus, errorThrown) => {
    //     //             Utils.checkErrorIsInvalidSessionToken(error);
    //     //             console.log(JSON.stringify(error));
    //     //             this.setState({
    //     //                 showSpinner : false
    //     //             });
    //     //         }
    //     //     );
    // }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps != null && nextProps.isActive) {
            return true;
        } else {
            return false;
        }
    }

    componentWillMount() {

        Utils.isUserSessionInvalid().then((response) => {
            // user session in valid
            this.setState({
                activeLocation : this.props.activeLocation,
                isUserSessionInvalid : true
            });

        }, (error) => {
            // console.log("error user session: "+JSON.stringify(error));
            // user session is invalid
            Utils.checkErrorIsInvalidSessionToken(error, this.context.router);

        });


    }

    componentWillReceiveProps(nextProps) {
        if (nextProps != null) {
            this.setState({
                activeLocation : nextProps.activeLocation
            });
        }
    }

    componentDidMount(){
        // this.fetchBillingDetails();
    }


    // getConstDisplayName(constStr) {
    //     const constMap = {
    //         "web"           : "Web",
    //         "webPlusMobile" : "Web + Mobile",
    //         "monthly"       : "Monthly",
    //         "oneYear"       : " 1 Year",
    //         "twoYear"       : " 2 Year"
    //     };
    //
    //     return constMap[constStr];
    // }


    render(){

        let currentUser      = Parse.User.current();
        let email            = currentUser.get("email");
        // let planType         = this.getConstDisplayName(this.state.locConfig.planType);
        // let subscriptionType = this.getConstDisplayName(this.state.locConfig.subscriptionType);

        return (
            <div className="section billing-pg">
                {/*{ this.props.showSpinner ? <Spinner/> : null }*/}
              <div className=" text-left">
                {/*<div className="row">*/}
                    {/*<div className="col-md-8 col-md-offset-2">*/}
                        {/*<div className="row">*/}
                          {/*<div className="col-xs-6">*/}
                              {/*<h1>Your Current Plan :</h1>*/}
                          {/*</div>*/}
                          {/*<div className="col-xs-6">*/}
                              {/*<p>*/}
                                  {/*<b> {planType}</b> <br/>*/}
                                  {/*<b> {subscriptionType}</b> <br/>*/}
                                  {/*${this.state.locConfig.planCharges} per Month*/}
                              {/*</p>*/}
                          {/*</div>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                {/*</div>*/}
                {/*<div className="row">*/}
                    {/*<div className="col-md-8 col-md-offset-2">*/}
                      {/*<div className="col-xs-6">*/}
                          {/*<h1>Transaction Fee :</h1>*/}
                      {/*</div>*/}
                      {/*<div className="col-xs-6">*/}
                          {/*<p> {this.state.locConfig.appFee} per Transaction </p>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                {/*</div>*/}
                  { this.state.isUserSessionInvalid ? (
                      <div className="">
                          <div className="col-md-8 col-md-offset-2">
                              <div className="col-md-6 no-gutter">
                                  <h3>Payment Information :</h3>
                              </div>
                              <div className="col-md-6 no-gutter">
                                  <p className={"d-inline-block"}>Email: {email}</p>
                                  <BankDetailsHolder activeLocation = {this.state.activeLocation} />
                                  <CardHolder activeLocation = {this.state.activeLocation} />
                              </div>
                          </div>
                      </div>
                  ) : null }


                  <div className="">
                      <div className="col-md-4 col-md-offset-4 card-header-container no-gutter">
                          <div className="card-header">
                              <span className="d-inline-block btn">
                                   <i className="material-icons">email</i>
                              </span>
                              <span className="d-inline-block"> <a href="#" className={"p-label"}>
                                  support@freshbytes.io
                              </a></span>
                          </div>

                          <div className="card-header">
                              <span className="d-inline-block btn">
                                  <i className="material-icons">call</i>
                              </span>
                              <span className="d-inline-block">(888)-96-37374</span>
                          </div>

                      </div>
                  </div>

               </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/dashboard/billing/billing.js